import api from './index'
import { axios } from '@/utils/request'

export function login (parameter) {
  return axios({
    url: '/webpublic/login',
    method: 'post',
    data: parameter
  })
}

export function logout () {
  return axios({
    url: '/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function modifyPassword (payload = {}) {
  return axios({
    url: '/user/modifyPwd',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: payload
  })
}

export function getPermissionsRoutes (parameter = {}) {
  return axios({
    url: '/webpublic/user/routes',
    method: 'post',
    data: parameter
  })
}

// 查询是否要googleAuth
export function getGoogleAuth() {
  return axios({
    url: '/googleAuth/findUser',
    method: 'get',
  })
}

// 查询信息googleAuth
export function getGoogleAuthMsg() {
  return axios({
    url: '/googleAuth',
    method: 'get',
  })
}

// 提交googleAuth
export function putGoogleAuthMsg(data) {
  return axios({
    url: '/googleAuth',
    method: 'put',
    data: data
  })
}

// 解绑googleAuth
export function deleteGoogleAuth(data) {
  return axios({
    url: '/googleAuth',
    method: 'delete',
    data: data
  })
}

// 验证googleAuth
export function GoogleAuthVerify(data) {
  return axios({
    url: '/webpublic/googleAuth/verify',
    method: 'post',
    data: data
  })
}
